module.exports = __webpack_public_path__ + "static/media/京东名称.3564a651.jpg";